import React from "react";
import Insights from "../Components/Insights/Index";
import DataInjection from "../Components/Data_Injection/Index";
import ViewPastUploads from "../Components/ViewPast_Uploads/Index";
import AuditUniverse from "../Components/Data_Injection/Audit-Universe/Index";
import Dashboard from "../pages/Dashboard";
import EDA from "../Components/Insights/EDA";
import FraudDetection from "../Components/Insights/Fraud_Detection";
import { label, path } from "framer-motion/client";
import ProcessMining from "../Components/Insights/Process-Mining/Index";
import AnnomolyDetection from "../Components/Insights/Annomoly-Detection/Index";
import SubModulePage from "../Components/Data_Injection/Audit-Universe/SubProcessModule";
import ProcessDetailsPage from "../Components/Data_Injection/Audit-Universe/ProcessDetailsPage";
import SubSubProcessModule from "../Components/Data_Injection/Audit-Universe/SubSubProcessModule";
import DashboardList from "../Components/Insights/EDA/DashboardList";
import EDADashboardDetail from "../Components/Insights/EDA/EDADashboardDetail";
import EDASegmentDetail from "../Components/Insights/EDA/EDASegmentDetail";
import EDACashInDashboardDetail from "../Components/Insights/EDA/EDACashInDashboardDetail";
import EDACashInSegmentDetail from "../Components/Insights/EDA/EDACashInSegmentDetail";

const routes = [
  // {
  //   path: "/",
  //   label: "Dashboard",
  //   element: <Dashboard />,
  // },
  {
    path: "/Insights",
    label: "Insights",
    children: [
      // {
      //   path: "EDA",
      //   label: "Financial Insights Dashboards",
      //   element: <DashboardList />,
      // },
      {
        path: "eda-dashboard-list",
        label: "Financial Insights Dashboards",
        element: <DashboardList/>,
        // hidden: true,
      },
      {
        path: "eda-dashboard-detail",
        label: "EDA Dashboard Detail",
        element: <EDADashboardDetail />,
        hidden: true,
      },
      {
        path: "eda-segment-detail",
        label: "EDA Segment Detail",
        element: <EDASegmentDetail />,
        hidden: true,
      },
      // {
      //   path: "eda-CashInsegment-detail",
      //   label: "EDA CashIn Segment Detail",
      //   element: <EDACashInSegmentDetail />,
      //   hidden: true,
      // },
      //  {
      //   path: "eda-CashIndashboard-detail",
      //   label: "EDA CashIn Dashboard Detail",
      //   element: <EDACashInDashboardDetail />,
      //   hidden: true,
      // },
      
      //{
       // path: "eda-dashboard-list",
        //label: "Dashboard List",
        //element: <DashboardList/>,
        //hidden: true,
     // }
     // {
       // path: "eda-dashboard-detail",
       // label: "EDA Dashboard Detail",
       // element: <EDADashboardDetail />,
       // hidden: true,
      //},
     // {
      //  path: "fraud-detection",
      //  label: "Fraud Detection",
       // element: <FraudDetection />,
     // },
     // {
      //  path: "process-mining",
      //  label: "Process Mining",
      //  element: <ProcessMining />,
      //},
     // {
      //  path: "annomoly-detection",
      //  label: "Annomoly Detection_AI-ML",
       // element: <AnnomolyDetection />,
      //},
    ],
  },

  {
    path: "/data-injection",
    label: "Data Ingestion",
    children: [
      // {
      //   index: true,
      //   label: "Data Injection",
      //   element: <DataInjection />,
      // },
      {
        path: "audit-universe",
        label: "Audit Universe",
        element: <SubSubProcessModule  />,
      },
      {
        path: "SubModulePage",
        label: "Sub-Module Page",
        element: <SubModulePage />,
        hidden: true,
      },
      {
        path: "SubSubProcessModule",
        label: "Sub-Sub-Process Module",
        element: <SubSubProcessModule />,
        hidden: true,
      },
      {
        path: "process-details",
        label: "Process Details",
        element: <ProcessDetailsPage />,
        hidden: true,
      },
    ],
  },
  {
    path: "/view-past-uploads",
    label: "View Past Uploads",
    element: <ViewPastUploads />,
  },
];

export default routes;
